import styled, { css } from "styled-components";
import buildColor from "@fdr/static-ui/ColorPalette";
import { fontNormal } from "@fdr/static-ui/Typography";
import { Link } from "react-router-dom";

export const Container = styled(Link)`
  display: flex;
  align-items: center;
  border-radius: 4px;
  min-width: 84px;
  cursor: pointer;
  text-decoration: none;
  border: 1px solid ${buildColor("blue")};
  height: 44px;
  ${({ isNightMode }) =>
    !isNightMode &&
    css`
      background-color: ${buildColor("white")};
    `};

  & svg {
    padding-right: 12px;
    color: ${buildColor("blue", "D1")};

    @media screen and (max-width: 340px) {
      padding-right: 4px;
    }
  }
`;

export const Text = styled.p`
  font-family: ${fontNormal};
  font-weight: normal;
  letter-spacing: 0;
  padding: 14px 8px 14px 16px;
  color: ${({ isNightMode }) =>
    isNightMode ? buildColor("white") : buildColor("blue", "D1")};
  font-size: 16px;

  @media screen and (max-width: 340px) {
    padding: 6px;
  }
`;
